module.exports = __webpack_public_path__ + "media/images/productIcon-1a76f757.svg";